<ul class="tab001">
	<li class="tab001__item">Terraço Itália</li>
	<li class="tab001__item">Temakeria & Cia</li>
	<li class="tab001__item">El Caridón</li>
	<li class="tab001__item">D'Heaven</li>
	<li class="tab001__item">Outback</li>
</ul>
